import * as React from 'react';

import { MenuItemLink } from 'react-admin';

const MenuItem = (props) => {
    return <MenuItemLink {...props} style={{background:props.bg}} />
}

export default MenuItem;